/* ----- COMPONENT BLOCK MAPPER ---- 
    1. It Maps contentful data when used on a page
    2. Automatically adds/formats your props
    3. Maps test data from -> "./test.data.tsx"
*/
import Component from '.';
import { Props, MapProps } from '../BlockMapper';
import TestData from './test.data';

const _map = (block: any, test = false) => {
  let data = test ? TestData : MapProps(block);
  const props: Props = { ...data };
  return <Component {...props} />;
};

export default _map;
